module.exports = __webpack_public_path__ + "20b1fd7f676aa94c05e68911ff6e3b72.png";